/*
 * Origine du widget Monext à charger, quand elle n'est pas celle du build.
 *
 * Le widget est servi depuis deux CDN distincts, un par environnement Monext, et
 * un token n'est affichable que par le widget de l'environnement qui l'a émis.
 * Tant que tous les golfs encaissaient sous le même compte marchand, l'origine
 * pouvait être figée à la compilation (`REACT_APP_PAYLINE_WIDGET_URL`). Ce n'est
 * plus vrai dès qu'un golf est déclaré en homologation côté serveur.
 *
 * Le serveur renvoie donc `widgetUrl` avec le token, et UNIQUEMENT dans ce cas :
 * en production le champ est nul et chaque application garde la valeur de son
 * build. Une coquille de configuration serveur ne peut donc pas casser le
 * paiement partout à la fois.
 *
 * L'état est volontairement porté par le module plutôt que par chaque écran :
 * les écrans de paiement passent déjà le token de `getToken` à leur générateur
 * de widget sans rien savoir de l'environnement, et leur faire transporter une
 * donnée de plus multiplierait les endroits où l'oublier.
 */

/*
 * La valeur est aussi miroitée sur l'objet global, sous un nom explicite.
 *
 * Les applications qui consomment ce paquet construisent le HTML du widget dans
 * leur propre service, et importer ce module depuis là créerait une dépendance
 * de compilation vers le paquet commun qui casse leurs suites de tests (le
 * paquet est lié en source, non transpilé par leur configuration Jest). Le
 * global est le canal le plus léger entre les deux, et il ne transporte qu'une
 * URL publique de CDN.
 */
export const GLOBAL_KEY = '__primaPaylineWidgetUrl';

const globalScope = typeof globalThis !== 'undefined' ? globalThis : null;

let activeWidgetUrl = null;

/* Appelé à la réception d'un token. `null` remet l'application sur son build. */
export const setActiveWidgetUrl = (url) => {
  activeWidgetUrl = typeof url === 'string' && url.length > 0 ? url : null;
  if (globalScope) globalScope[GLOBAL_KEY] = activeWidgetUrl;
};

/* Origine à utiliser, ou `null` si le build fait foi. */
export const getActiveWidgetUrl = () => activeWidgetUrl;

export default { setActiveWidgetUrl, getActiveWidgetUrl };
